import { create } from 'zustand'
import {
  buildConsent,
  clearTrackingCookies,
  clearTrackingStorage,
  ConsentState,
  getConsent,
  googleConsent,
  saveConsent,
} from '@/utils/consent'

type GtagFn = (...args: unknown[]) => void
type FbqFn = (...args: unknown[]) => void

// The visitor's cookie choice on TBL pages, shared by the banner, the footer's "Cookie Settings"
// link and the scripts it gates. `consent` is null until read in the browser or while undecided.
interface ConsentStoreState {
  consent: ConsentState | null
  isBannerOpen: boolean
  init: () => void
  choose: (acceptAll: boolean) => void
  openSettings: () => void
  closeSettings: () => void
}

export const useConsentStore = create<ConsentStoreState>((set, get) => ({
  consent: null,
  isBannerOpen: false,
  init: () => {
    const consent = getConsent()
    set({ consent, isBannerOpen: !consent })
  },
  choose: (acceptAll) => {
    const consent = buildConsent(acceptAll, new Date())
    const previous = get().consent
    saveConsent(consent)

    const { gtag, fbq } = window as unknown as { gtag?: GtagFn; fbq?: FbqFn }
    gtag?.('consent', 'update', googleConsent(consent))

    const isWithdrawal =
      (previous?.analytics && !consent.analytics) || (previous?.marketing && !consent.marketing)
    if (isWithdrawal) {
      fbq?.('consent', 'revoke')
      clearTrackingCookies()
      clearTrackingStorage()
      window.location.reload()
      return
    }

    if (consent.marketing) fbq?.('consent', 'grant')
    set({ consent, isBannerOpen: false })
  },
  openSettings: () => set({ isBannerOpen: true }),
  closeSettings: () => {
    if (get().consent) set({ isBannerOpen: false })
  },
}))
